<template>
  <div
    class="z-10 hidden min-h-screen flex-col items-center justify-center md:flex dark:border-r dark:border-r-white"
  >
    <div class="flex flex-col items-center gap-6 p-6">
      <CremaLogo class="h-24 w-24 text-primary-500" />
      <h1 class="text-4xl font-medium text-white">Crema Manager</h1>
    </div>
  </div>
</template>

<script>
import CremaLogo from '../../layouts/main-layout/CremaLogo.vue'

export default {
  name: 'LoginLeftSide',
  components: { CremaLogo }
}
</script>
